import React, { useContext, useEffect, useState } from "react";
const defaultUserInfo = {
    identityProvider: undefined,
    userId: undefined,
    userDetails: undefined,
    userRoles: [],
};
const UserInfoContext = React.createContext(defaultUserInfo);
const UserInfoContextProvider = ({ children }) => {
    const [userInfo, setUserInfo] = useState(defaultUserInfo);
    useEffect(() => {
        const run = async () => {
            const res = await fetch("/.auth/me");
            const json = await res.json();
            if (json.clientPrincipal) {
                setUserInfo(json.clientPrincipal);
            }
        };
        run();
    }, []);
    return (React.createElement(UserInfoContext.Provider, { value: userInfo }, children));
};
const useUserInfo = () => useContext(UserInfoContext);
export { UserInfoContextProvider, useUserInfo };
//# sourceMappingURL=UserInfoContext.js.map